import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { ICDNAuxMode } from "app/order-entry/data-idc/enums/icd-aux-mode.enum";

export class ICLimitPriceModel {
  public mode: ICDNAuxMode = null;
  public activated: boolean = null;
  public value: CubiqTS.BigNumber;
  public textValue: string;
}
